var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustodialWallet1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 20,
    viewBox: "0 0 70 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_24",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.222168 0.562378H19.542V19.9034H0.222168V0.562378Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_24)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.906 17.0757L11.7664 15.3421H8.13447C6.87871 15.3421 5.86084 14.3241 5.86084 13.0683V11.1058C5.86084 9.85007 6.87871 8.83209 8.13447 8.83209H11.6322C12.888 8.83209 13.906 9.85007 13.906 11.1058V17.0757ZM13.5626 4.27026H5.8566C5.8566 2.22242 4.19666 0.562256 2.1487 0.562256H0.222168V4.27026V6.09022V13.924C0.222168 17.2263 2.89921 19.9034 6.20139 19.9034H13.5626C16.8649 19.9034 19.542 17.2263 19.542 13.924V10.2496C19.542 6.9473 16.8649 4.27026 13.5626 4.27026Z",
    fill: "#070E1B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6484 17.0693L25.1963 19.1759H25.212L25.7876 17.0693H26.2369L26.8125 19.1759H26.8282L27.3761 17.0693H27.861L27.0489 19.7745H26.5917L26.0202 17.687H26.0044L25.4329 19.7745H24.9716L24.1636 17.0693H24.6484Z",
    fill: "#070E1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7253 17.0693L30.2732 19.1759H30.289L30.8645 17.0693H31.3138L31.8895 19.1759H31.9051L32.4531 17.0693H32.9379L32.1259 19.7745H31.6686L31.0972 17.687H31.0813L30.5098 19.7745H30.0485L29.2405 17.0693H29.7253Z",
    fill: "#070E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8036 17.0693L35.3516 19.1759H35.3674L35.9428 17.0693H36.3922L36.9677 19.1759H36.9835L37.5315 17.0693H38.0163L37.2042 19.7745H36.747L36.1754 17.687H36.1597L35.5881 19.7745H35.1269L34.3188 17.0693H34.8036Z",
    fill: "#070E1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1854 19.3123C40.2407 19.3653 40.2722 19.4336 40.2722 19.5169C40.2722 19.5926 40.2407 19.6608 40.1854 19.7177C40.1264 19.767 40.0553 19.7935 39.9766 19.7935C39.8898 19.7935 39.8228 19.767 39.7715 19.7177C39.7124 19.6608 39.6848 19.5926 39.6848 19.5169C39.6848 19.4336 39.7124 19.3653 39.7715 19.3123C39.8228 19.2593 39.8898 19.2327 39.9766 19.2327C40.0553 19.2327 40.1264 19.2593 40.1854 19.3123Z",
    fill: "#070E1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6226 19.4334H43.4188C43.6002 19.4334 43.7421 19.403 43.8444 19.35C43.9706 19.2781 44.0376 19.1644 44.0376 19.0091C44.0376 18.8498 43.9863 18.7323 43.8879 18.6604C43.7892 18.5884 43.6356 18.5543 43.4306 18.5543H42.6226V19.4334ZM42.6226 18.2173H43.3636C43.5607 18.2173 43.7026 18.1832 43.7892 18.1188C43.876 18.0506 43.9193 17.9444 43.9193 17.8005C43.9193 17.6641 43.876 17.5657 43.7892 17.5049C43.7026 17.4406 43.5607 17.4103 43.3715 17.4103H42.6226V18.2173ZM43.4789 17.0693C43.7548 17.0693 43.9677 17.13 44.1253 17.2588C44.2751 17.38 44.35 17.543 44.35 17.7514C44.35 17.903 44.3106 18.0318 44.2318 18.1379C44.1529 18.2363 44.0465 18.3121 43.9046 18.3614C44.0898 18.3955 44.2318 18.4674 44.3263 18.5773C44.421 18.6872 44.4683 18.835 44.4683 19.0168C44.4683 19.2896 44.3697 19.4866 44.1766 19.6154C44.0111 19.7215 43.7785 19.7745 43.4789 19.7745H42.1938V17.0693H43.4789Z",
    fill: "#070E1B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13_24",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 20
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.222168 19.9034H70V0.562378H0.222168V19.9034Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13_24)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2498 19.7745H46.6755V17.0693H46.2498V19.7745Z",
    fill: "#070E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9113 17.0693L49.5972 18.0468L50.2831 17.0693H50.8074L49.8534 18.3765L50.8745 19.7745H50.3501L49.5972 18.7023L48.8445 19.7745H48.3201L49.3332 18.3765L48.387 17.0693H48.9113Z",
    fill: "#070E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5182 19.7745H52.9439V17.0693H52.5182V19.7745Z",
    fill: "#070E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2775 17.0693L56.7163 19.0811H56.7321V17.0693H57.1617V19.7745H56.7439L55.2893 17.74H55.2736V19.7745H54.844V17.0693H55.2775Z",
    fill: "#070E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5909 19.3123C59.6461 19.3653 59.6777 19.4336 59.6777 19.5169C59.6777 19.5926 59.6461 19.6608 59.5909 19.7177C59.5319 19.767 59.4608 19.7935 59.3821 19.7935C59.2953 19.7935 59.2283 19.767 59.1771 19.7177C59.1179 19.6608 59.0903 19.5926 59.0903 19.5169C59.0903 19.4336 59.1179 19.3653 59.1771 19.3123C59.2283 19.2593 59.2953 19.2327 59.3821 19.2327C59.4608 19.2327 59.5319 19.2593 59.5909 19.3123Z",
    fill: "#070E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.266 17.0693L68.2476 19.2365H68.2594L69.237 17.0693H69.7455V19.7745H69.3159V17.8423H69.3L68.4369 19.7745H68.0662L67.203 17.8423H67.1872V19.7745H66.7576V17.0693H67.266Z",
    fill: "#070E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8323 14.0524H40.5373V4.65735H38.8323V14.0524Z",
    fill: "#070E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2649 4.65735H50.1316L47.928 7.73274L45.7145 4.65735H43.5933L46.8743 9.1835L43.3311 14.0524H45.4676L47.9292 10.6151L50.3909 14.0524H52.5272L48.9841 9.1835L52.2649 4.65735Z",
    fill: "#070E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5776 14.0524H56.2828V4.65735H54.5776V14.0524Z",
    fill: "#070E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0324 4.41492V11.2967L59.5481 4.41492H58.1134V14.0764H59.8414V7.15058L68.3479 14.0764H69.7604V4.41492H68.0324Z",
    fill: "#070E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1718 11.445C34.1718 11.9342 33.7752 12.3309 33.2858 12.3309H26.0737V6.15488H32.6793C32.7628 6.15488 32.8514 6.15488 32.9406 6.15477C33.417 6.15455 33.8031 6.54058 33.8032 7.01691V7.37336C33.8033 7.84946 33.4172 8.23561 32.941 8.23561H32.8272H29.2937L31.4524 9.98133H33.286C33.7752 9.98133 34.1718 10.3779 34.1718 10.8671V11.445ZM35.145 8.89862L35.1285 8.88322L35.1413 8.86475C35.4227 8.45463 35.5596 7.99942 35.5596 7.56774V6.96461C35.5596 6.89004 35.5597 6.80536 35.5598 6.7133C35.5623 5.44203 34.5321 4.40975 33.261 4.40942C33.1677 4.40942 33.0815 4.40942 33.0045 4.40942H24.3278V14.0765H33.5611C34.9501 14.0765 35.9317 13.0759 35.9317 11.7267L35.9172 10.4797C35.9172 9.93629 35.6358 9.35999 35.145 8.89862Z",
    fill: "#070E1B"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5252 17.074C60.8944 17.074 60.3831 17.5853 60.3831 18.2161V18.6107C60.3831 19.2414 60.8944 19.7528 61.5252 19.7528C61.9622 19.7528 62.3419 19.5074 62.5339 19.1469L62.1588 18.9867C62.0195 19.1869 61.7877 19.318 61.5252 19.318C61.0992 19.318 60.7539 18.9726 60.7539 18.5466V18.2802C60.7539 17.8541 61.0992 17.5088 61.5252 17.5088C61.8106 17.5088 62.0597 17.6637 62.1931 17.894L62.5914 17.8058C62.4266 17.3777 62.0114 17.074 61.5252 17.074Z",
    fill: "#070E1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.657 17.074C64.0263 17.074 63.5149 17.5853 63.5149 18.2161V18.6107C63.5149 19.2414 64.0263 19.7528 64.657 19.7528C65.2878 19.7528 65.7992 19.2414 65.7992 18.6107V18.2161C65.7992 17.5853 65.2878 17.074 64.657 17.074ZM64.6571 17.5168C64.2349 17.5168 63.8926 17.8591 63.8926 18.2814V18.5454C63.8926 18.9677 64.2349 19.3099 64.6571 19.3099C65.0793 19.3099 65.4216 18.9677 65.4216 18.5454V18.2814C65.4216 17.8591 65.0793 17.5168 64.6571 17.5168Z",
    fill: "#070E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustodialWallet1);
export default __webpack_public_path__ + "static/media/custodial-wallet1.6eedf1cddfaced7d2e83f1ea7ee71b50.svg";
export { ForwardRef as ReactComponent };